import { data } from "@escapio/shared/state/payload";
import { loadMapLibre } from "@escapio/portal/components/map/map-libre/load";

/**
 * @typedef {import('maplibre-gl').Map} Map
 * @typedef {import('maplibre-gl').MapOptions} MapOptions
 *
 * @param {HTMLElement} container
 * @param {string} langId
 * @param {MapOptions} options
 * @return {Promise<Map>}
 */
export async function createMap(container, langId, options = {}) {
	const { Map, NavigationControl } = await loadMapLibre();
	const map = new Map({ container, style: createGLStyle(langId), ...options });
	if (!options.hasOwnProperty("interactive") || options.interactive) {
		map.addControl(new NavigationControl({}));
	}
	return map;
}

function createGLStyle(langId) {
	const forCMS = data.maps_tiles_use_cms_style;
	return `${data.maps_tiles_host}styles/${langId}${forCMS ? "-cms" : ""}/style.json`;
}
